import { default as invoiceMinus } from "../../../icons/invoiceMinus.svg";
import { default as invoiceGreenDot } from "../../../icons/invoiceGreenDot.svg";
import { default as invoiceRedDot } from "../../../icons/invoiceRedDot.svg";

import React, { useEffect, useState } from "react";
import "../InvoicePage.scss";
import { Returntext } from "../../Landings/common/returnText";
import { useContent, useLanguages } from "../../../hooks/content";
import { OrderStatusEnum } from "../order-status.enum";
import { getLastRelevantStatus } from "../utils/deliveryProgressUtils";

function InvoiceOrderComponent({ props, pdf }) {
    const { lang } = useLanguages();
    const { contentManagementData } = useContent();
    const [data, setData] = useState([]);

    useEffect(() => {
        const orders = props.map(item => {
            let statusValue;
            let statusClassName = 'progress';

            const lastRelevantStatus = getLastRelevantStatus(item.statuses ?? []);
            const currentStatus = lastRelevantStatus?.status;

            switch (currentStatus) {
                case OrderStatusEnum.RECEIVED_IN_US_WAREHOUSE:
                    statusValue = Returntext(contentManagementData, 'poi_content_order_status_value_received_in_usa', lang);
                    break;
                case OrderStatusEnum.AIR_SHIPPED_FROM_US:
                    statusValue = Returntext(contentManagementData, 'poi_content_order_status_value_air_shipped_from_us', lang);
                    break;
                case OrderStatusEnum.RECEIVED_IN_TBILISI_WAREHOUSE:
                    statusValue = Returntext(contentManagementData, 'poi_content_order_status_value_received_in_tbilisi', lang);
                    break;
                case OrderStatusEnum.SEND_TO_REGION:
                    statusValue = Returntext(contentManagementData, 'poi_content_order_status_value_send_to_region', lang);
                    break;
                case OrderStatusEnum.OUT_FOR_DELIVERY:
                    statusValue = Returntext(contentManagementData, 'poi_content_order_status_value_out_for_delivery', lang);
                    break;
                case OrderStatusEnum.FAILED_DELIVERY:
                    statusValue = Returntext(contentManagementData, 'poi_content_order_status_value_failed_delivery', lang);
                    statusClassName = 'error';
                    break;
                case OrderStatusEnum.DELIVERED:
                    statusValue = Returntext(contentManagementData, 'poi_content_order_status_value_delivered', lang);
                    statusClassName = 'success';
                    break;
                default:
                    statusValue = 'Unknown';
                    break;
            }

            return {
                tracking: { key: item.tracking_number, value: statusValue, status: statusClassName },
                receiver: {
                    key: Returntext(contentManagementData, 'poi_content_order_receiver', lang),
                    value: `${ item.receiver.first_name } ${ item.receiver.last_name }`
                },
                warehouse: {
                    key: Returntext(contentManagementData, 'poi_content_order_delivered_at_warehouse', lang),
                    value: item.delivered_warehouse_date
                },
                delivery: {
                    key: Returntext(contentManagementData, 'poi_content_order_estimated_receipt', lang),
                    value: item.estimated_acceptance_date
                },
                weight: {
                    key: Returntext(contentManagementData, 'poi_content_order_weight', lang),
                    value: item.weight
                },
                payment: {
                    key: Returntext(contentManagementData, 'poi_content_order_payment_status', lang),
                    value: item.paid
                },
            };
        })

        setData(orders);
    },[lang])

    return (
        <div className="invoice-sheet">
            <div className="invoice-title">
                <span>{ Returntext(contentManagementData, 'poi_sheet_title_orders', lang) }</span>
                <img src={invoiceMinus} alt="minus"/>
            </div>
            <div className="invoice-sheet-container">
                {
                    data.map((item, index) => {
                        return (
                            <div className="invoice-content-item" key={index}>
                                <div className="invoice-item tracking">
                                    <div>{ item.tracking.key }</div>
                                    <span className={ item.tracking.status }>
                                        { item.tracking.value }
                                    </span>
                                </div>
                                <div className="invoice-item">
                                    <div> { item.receiver.key } </div>
                                    <span> { item.receiver.value } </span>
                                </div>
                                {
                                    pdf === true
                                        ? (
                                            <div className="invoice-item">
                                                <div> { item.weight.key }  </div>
                                                <span> { item.weight.value } kg </span>
                                            </div>
                                        )
                                        : (
                                            <>
                                                <div className="invoice-item">
                                                    <div> { item.warehouse.key } </div>
                                                    <span> { item.warehouse.value ? item.warehouse.value : 'N/A' } </span>
                                                </div>
                                                <div className="invoice-item">
                                                    <div> { item.delivery.key } </div>
                                                    <span> { item.delivery.value ? item.delivery.value : 'N/A' } </span>
                                                </div>
                                            </>
                                        )
                                }

                                <div className="invoice-item">
                                    <div> { item.payment.key } </div>
                                    <div>
                                        <img src={ item.payment.value ? invoiceGreenDot : invoiceRedDot } alt="dot"/>
                                        <span>
                                            {
                                                item.payment.value === true
                                                    ? Returntext(contentManagementData, 'poi_content_order_payment_status_paid_value', lang)
                                                    : Returntext(contentManagementData, 'poi_content_order_payment_status_not_paid_value', lang)
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default InvoiceOrderComponent;